import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import { IS_PRODUCTION_ENV } from './constants'

const shouldEnablePerformance = () => {
  const isCookieForced = () => {
    return Number(getCSRCookieData('_IL-performance-mode')) > 0
  }

  const isEnvForced = () => {
    return process.env.NODE_ENV === 'development'
  }
  const enabled = !IS_PRODUCTION_ENV || isCookieForced() || isEnvForced()

  return enabled
}

export default shouldEnablePerformance
